import { render, staticRenderFns } from "./GeodesiaRecordsList.vue?vue&type=template&id=e923f084&scoped=true"
import script from "./GeodesiaRecordsList.vue?vue&type=script&lang=js"
export * from "./GeodesiaRecordsList.vue?vue&type=script&lang=js"
import style0 from "./GeodesiaRecordsList.vue?vue&type=style&index=0&id=e923f084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e923f084",
  null
  
)

export default component.exports